<template>
  <div class="subscriptions-archive">
    <div class="coming-soon-state">
      <img src="@/assets/MyWorkBench/archive/empty.svg" alt="Empty" class="empty-icon" />
      <p class="empty-text">Subscriptions archive coming soon...</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubscriptionsArchive',
};
</script>

<style scoped>
.subscriptions-archive {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.coming-soon-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  padding: 40px 20px;
  text-align: center;
  gap: 16px;
}

.empty-icon {
  width: 350px;
  height: 230px;
}

.empty-text {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #333;
  margin: 0;
}
</style>
